import type { CurrencyCode } from '@99designs/i18n';
import type { MarketingKey } from '@99designs/marketing-ui';

type SavingsAmount = {
    [key in MarketingKey]: { [key in CurrencyCode]: number | string };
};

export const getSavingsAmountInCents = (
    marketingKey: MarketingKey,
    currency: CurrencyCode
): number | string | undefined => {
    const savingsAmounts: Partial<SavingsAmount> = {
        'logo-brand-guide': {
            AUD: 10900,
            CAD: 9900,
            CHF: 6900,
            DKK: 49900,
            EUR: 6900,
            GBP: 6900,
            HKD: 49900,
            JPY: 9599,
            MXN: 149900,
            NOK: 69900,
            SGD: 9900,
            USD: '40%',
        },
        'logo-business-card-design': {
            AUD: 7900,
            CAD: 6900,
            CHF: 4900,
            DKK: 29900,
            EUR: 4900,
            GBP: 3900,
            HKD: 39900,
            JPY: 6799,
            MXN: 109900,
            NOK: 49900,
            SGD: 6900,
            USD: 4900,
        },
        'logo-social-media-pack': {
            AUD: 21700,
            CAD: 18700,
            CHF: 13700,
            DKK: 97700,
            HKD: 105700,
            JPY: 18997,
            MXN: 289700,
            EUR: 14700,
            NOK: 236700,
            SGD: 19700,
            GBP: 12700,
            USD: 13700,
        },
        'logo-brand-identity-pack': {
            AUD: '39%+',
            CAD: '38%+',
            CHF: '40%+',
            DKK: '39%+',
            EUR: '39%+',
            GBP: '38%+',
            HKD: '39%+',
            JPY: '39%+',
            MXN: '39%+',
            NOK: '39%+',
            SGD: '39%+',
            USD: '39%+',
        },
        'brand-starter-pack': {
            AUD: 0,
            CAD: 0,
            CHF: 0,
            DKK: 0,
            EUR: 0,
            GBP: 0,
            HKD: 0,
            JPY: 0,
            MXN: 0,
            NOK: 0,
            SGD: 0,
            USD: '20%+',
        },
        'brand-launch-pack': {
            AUD: 0,
            CAD: 0,
            CHF: 0,
            DKK: 0,
            EUR: 0,
            GBP: 0,
            HKD: 0,
            JPY: 0,
            MXN: 0,
            NOK: 0,
            SGD: 0,
            USD: '25%+',
        },
    };

    return savingsAmounts?.[marketingKey]?.[currency];
};
